export default {
    stripeKey: 'pk_live_51QTU5RCVb1sBHLpN7FFigAiNwdNAEc2BUR8lMfjTSQWAhKpyAErKSoqi0EX8CCIpMhT5wTiXagW4359zXlT131v9008emcjKea',
    debug: false,
    soon: false,
    checkSoon: host => false,
    directives: {
        connectSrc: [
            "api.touryup.com", "cdn.touryup.com", "www.touryup.com",
            "*.elfsight.com", "*.clarity.ms",
            "www.google-analytics.com",
            "www.googletagmanager.com",
            "*.google.com",
            "stats.g.doubleclick.net",
            "mc.yandex.ru",
            "cdn.linkedin.oribi.io",
            "pagead2.googlesyndication.com",
        ],
        defaultSrc: [
            "cdn.touryup.com",
            "bid.g.doubleclick.net",
            "tpc.googlesyndication.com",
        ],
        imgSrc: [
            "blob:", "cdn.touryup.com", "www.touryup.com",
            "www.facebook.com", "connect.facebook.com", "connect.facebook.net",

            "googleads.g.doubleclick.net", "www.google.com", "www.google.az", 'www.google.me', 'www.google.nl',
            "*.google-analytics.com", "*.googletagmanager.com",
            "ssl.google-analytics.com", "stats.g.doubleclick.net",
            "ssl.gstatic.com", "www.gstatic.com", "*.googleadservices.com",
            "fonts.gstatic.com",

            "px.ads.linkedin.com", "www.linkedin.com",

            "mc.yandex.ru",
            "static.elfsight.com",
            "files.elfsightcdn.com"
        ],
        fontSrc: [
            "data:",
            "fonts.gstatic.com",
        ],
        scriptSrc: [
            "blob:",
            "tagmanager.google.com",
            "*.googletagmanager.com",
            "www.google-analytics.com", "ssl.google-analytics.com",
            "www.google-analytics.com",
            "www.googleadservices.com", "www.google.com",
            "googleads.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "connect.facebook.net",
            "mc.yandex.ru", "book.touryup.com"
        ],
        styleSrc: [
            "tagmanager.google.com", "fonts.googleapis.com", "book.touryup.com"
        ],
        frameSrc: ['*.google.com', 'mc.yandex.ru', 'td.doubleclick.net', 'www.googletagmanager.com', 'js.stripe.com'],
        frameAncestors: ["*"],
        formAction: ["*"]
    },
    urls: {
        api: 'api.touryup.com',
        cdn: 'cdn.touryup.com',
        site: 'book.touryup.com'
    },
    title: 'TourYup',
    recaptchaKey: '6LdM6mApAAAAAD84Aw13SbyJBkj4Z54rN2DCEdt8',
    //robots: "index, follow"
}
